import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { Watch } from "react-loader-spinner";
import { toast } from "react-toastify";
import axios from "axios";
import Select from "react-select";
import Crop from "../../shared/crop";


const customStyles = {
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const customRequireStyles = {
  control: (base) => ({ ...base, borderColor: "red" }),
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const AddVehicle = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState("");
  const [isError, setError] = useState(false);
  const [VehicleDrp, setVehicleDrpData] = useState([]);
  const [cityDrp, setCityDrpData] = useState([]);
  const [stateDrp, setStateDrpData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState({
    id: null,
    name: "",
    country_id: "101",
    vehicle_category_id: "",
    city_id: null,
    state_id: null,
    address: "",
    id_number: "",
    phone_number: "",
    image: ""
  });

  const getVehicleCategory = () => {
    axios.post(API_URL.VEHICLE_CATEGORY_LIST, {}).then((res) => {
      setVehicleDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name + ' - ' + caw.capacity + ' Kg',
          value: caw.id,
        };
      });
      setVehicleDrpData(cd);
    });
  };

  const getState = () => {
    axios.post(API_URL.STATE_LIST, { country_id: 101 }).then((res) => {
      setStateDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setStateDrpData(cd);
    });
  };


  const getCityData = () => {
    axios
      .post(API_URL.CITY_LIST, { state_id: formValue.state_id })
      .then((res) => {
        setCityDrpData(res.data.data);
        let cd = res.data.data.map((caw) => {
          return {
            label: caw.name,
            value: caw.id,
          };
        });
        setCityDrpData(cd);
      });
  };


  const onSave = () => {
    if (formValue.name &&
      formValue.city_id &&
      formValue.phone_number &&
      formValue.address &&
      formValue.vehicle_category_id &&
      formValue.state_id
    ) {
      setError(false);
      setLoading(true);
      const pUrl = id ? API_URL.VEHICLE_UPDATE : API_URL.VEHICLE_SAVE;
      axios
        .post(pUrl, formValue)
        .then((res) => {
          if (res.data.status === 1) {
            let message = id
              ? "Vehicles Updated Successfully."
              : "Vehicles Created Successfully.";
            toast.success(message, { autoClose: 3000, position: "top-right" });
            setLoading(false);
            navigate("/settings/vehicles");
          }
        })
        .finally(() => {
          setLoading(false);
          setError(true);
        });
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const onEdit = () => {
    axios.post(API_URL.VEHICLE_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormValue({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          address: res.data.data.address ? res.data.data.address : "",
          city_id: res.data.data.city_id ? res.data.data.city_id : "",
          state_id: res.data.data.state_id ? res.data.data.state_id : "",
          id_number: res.data.data.id_number ? res.data.data.id_number : "",
          phone_number: res.data.data.phone_number ? res.data.data.phone_number : "",
          image: null,
          vehicle_category_id: res.data.data.vehicle_category_id ? res.data.data.vehicle_category_id : "",
        });
        if (res.data.data.image) {
          setImagePreview(res.data.data.image);
        }
      }
    });
  };

  const isRequiredField = (key) => {
    return isError && !formValue[key];
  };

  useEffect(() => {
    getVehicleCategory();
    getState();
  }, []);

  useEffect(() => {
    getCityData();
  }, [formValue.state_id]);

  useEffect(() => {
    id && onEdit();
  }, [id]);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>{id ? "Edit" : "Add"} Vehicles</h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/settings/vehicles"} className="btn btn-secondary">
              <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
            </Link>
          </div>
        </div>
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={(event) => event.preventDefault()}>
                <div className="row">
                  <div className="col-md-3">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Image<span className="required-star">*</span></label>
                          <div
                            className={isRequiredField("image") && "required-box"}
                          >
                            <Crop
                              imagePreview={imagePreview}
                              cropShape={"round"}
                              guid={""}
                              height={250}
                              width={250}
                              onChangeCropper={async ({
                                fileCropped,
                                fileCroppedBase64,
                              }) => {
                                setFormValue({
                                  ...formValue,
                                  image: fileCroppedBase64,
                                });
                                setImagePreview(fileCroppedBase64);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="row">
                      <div className="col-md-4 col-md-4 col-sm-12">
                        <div className="form-group">
                          <label>
                            Vehicles Category<span className="required-star">*</span>
                          </label>
                          <Select
                            options={VehicleDrp}
                            value={VehicleDrp.find(
                              (r) => r.value === formValue.vehicle_category_id
                            )}
                            styles={
                              isRequiredField("vehicle_category_id")
                                ? customRequireStyles
                                : customStyles
                            }
                            onChange={(e) => {
                              setFormValue({ ...formValue, vehicle_category_id: e.value });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label>Name<span className="required-star">*</span></label>
                          <input
                            type="text"
                            name="name"
                            value={formValue.name}
                            className={
                              isRequiredField("name")
                                ? "form-control required"
                                : "form-control"
                            }
                            id="name"
                            onChange={(event) => {
                              setFormValue({
                                ...formValue,
                                name: event.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label>Contact Number<span className="required-star">*</span></label>
                          <input
                            type="text"
                            name="name"
                            value={formValue.phone_number}
                            className={
                              isRequiredField("name")
                                ? "form-control required"
                                : "form-control"
                            }
                            id="name"
                            onChange={(event) => {
                              setFormValue({
                                ...formValue,
                                phone_number: event.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label>
                            State<span className="required-star">*</span>
                          </label>
                          <Select
                            options={stateDrp}
                            value={stateDrp.find(
                              (r) => r.value === formValue.state_id
                            )}
                            styles={
                              isRequiredField("state_id")
                                ? customRequireStyles
                                : customStyles
                            }
                            onChange={(e) => {
                              setFormValue({ ...formValue, state_id: e.value });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label>
                            City<span className="required-star">*</span>
                          </label>
                          <Select
                            options={cityDrp}
                            value={cityDrp.find(
                              (r) => r.value === formValue.city_id
                            )}
                            styles={
                              isRequiredField("city_id")
                                ? customRequireStyles
                                : customStyles
                            }
                            onChange={(e) => {
                              setFormValue({ ...formValue, city_id: e.value });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label>Address<span className="required-star">*</span></label>
                          <input
                            type="text"
                            name="address"
                            value={formValue.address}
                            className={
                              isRequiredField("address")
                                ? "form-control required"
                                : "form-control"
                            }
                            id="address"
                            onChange={(event) => {
                              setFormValue({
                                ...formValue,
                                address: event.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label>Vehicle Number<span className="required-star">*</span></label>
                          <input
                            type="text"
                            name="name"
                            value={formValue.id_number}
                            className={
                              isRequiredField("id_number")
                                ? "form-control required"
                                : "form-control"
                            }
                            id="id_number"
                            onChange={(event) => {
                              setFormValue({
                                ...formValue,
                                id_number: event.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group text-right">
                    <button
                      type="submit"
                      onClick={onSave}
                      disabled={loading}
                      className="btn btn-primary"
                    >
                      {loading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Watch color={"white"} height={20} width={20} />
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddVehicle;
